import { createContext } from 'react'

import type { CompoundIconName } from './foundations/icon/names.ts'

export type ButtonClickContext = {
  buttonName?: string | undefined
  buttonText?: string | undefined
  buttonIcon?: CompoundIconName | undefined
}

export type TabViewContext = {
  tabId: string
}

export const TrackButtonClickContext = createContext<(context: ButtonClickContext) => void>((context) => {
  // eslint-disable-next-line no-console
  console.warn('clickButtonCallback has been used but the context was not available to handle the call', context)
})

export const TrackTabViewContext = createContext<(context: TabViewContext) => void>((context) => {
  // eslint-disable-next-line no-console
  console.warn('viewTabCallback has been used but the context was not available to handle the call', context)
})
